import API from "./API";
import {writable} from "svelte/store";

const  mm = writable(false);

const R = {
    handle: async (func, params, success, failure) => {
        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);
        if (result.error) {
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    tickets: {
        init: () => API.POST(`eTicket/init`),
        save: (transaction) => API.POST(`eTicket/saveTempData`, transaction),
    },

    hotel: {
        search: (data) => API.POST(`hotel/search`, data),
        index: () => API.POST(`hotel/all`),
    },

    pickupPoint: {
        routes: (data) => API.POST(`pickupPoint/routes`, data),
        nearby: (data) => API.POST(`pickupPoint/nearby`, data),
        yearly: (data) => API.POST(`pickupPoint/yearly`, data),
    },

};

export default R;
export {mm as requestingStore};